<template>
  <v-container fluid>
    <h2 class="mb-3">{{$t('leave')}}</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
        <!-- <v-tab>{{$t('leave_approval')}}</v-tab> -->
        <v-tab>{{$t('leave_balance')}}</v-tab>
        <v-tab>{{$t('manage_leave_category')}}</v-tab>
        <!-- <v-tab-item>
          <v-container fluid>
            <approval v-if="tabActive == 0"></approval>
          </v-container>
        </v-tab-item> -->
        <v-tab-item>
          <v-container fluid>
            <balance v-if="tabActive == 0"></balance>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <category v-if="tabActive == 1"></category>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
  // import Approval from "./components/Approval";
  import Balance from "./components/Balance";
  import Category from "./components/Category";
  export default {
    name: "LeaveBalance",
    data() {
      return {
        tabActive: 0,
      };
    },
    methods: {
      changeActiveTab(e) {
        this.tabActive = e;
      },
    },
    computed: {
      gcClaimEnabled() {
        return this.$store.getters.gcGetData('feature_claim', 'is_enabled')
      },
    },
    created() {},
    components: {
      // Approval,
      Balance,
      Category
    },
  };
</script>